import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3c8f3d86"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "cmpLayer" }
const _hoisted_2 = { style: {"margin":"10px auto","display":"flex","flex-direction":"row","justify-content":"center"} }
const _hoisted_3 = ["src"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { style: {"text-align":"center"} }, "We Care About Your Privacy", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"font-weight":"900"} }, "Our site is supported by personalized advertising shown to you while you visit. Your consent helps make this content available to everyone and your support is appreciated.", -1))
const _hoisted_6 = { style: {"border":"1px solid #e0e0e0","border-radius":"12px","padding":"8px","margin-top":"12px"} }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "We and our partners process personal data such as IP address, visitor profiles and browsing data for the purpose of personalizing and targeting advertising. In accordance with the California Privacy Rights Act (CPRA), you may opt out of our collection of data and sharing with third parties by changing the options below and clicking the 'Save Choices' button:", -1))
const _hoisted_8 = { class: "cmpButtonContainer" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {} }, "Save Choices", -1))
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"margin-left":"-14px"} }, "Accept All", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "cmpSVGButtonArrow",
  "clip-rule": "evenodd",
  "fill-rule": "evenodd",
  "stroke-linejoin": "round",
  "stroke-miterlimit": "2",
  viewBox: "0 0 500 500",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    class: "__cmpIcon",
    d: "M479.3 250L246.5 482.7l-67.1-67L345 250 179.4 84.4l67.1-67.1L479.3 250z"
  })
], -1))
const _hoisted_13 = [
  _hoisted_11,
  _hoisted_12
]
const _hoisted_14 = { key: 0 }
const _hoisted_15 = ["href"]
const _hoisted_16 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ConsentItem = _resolveComponent("ConsentItem")!
  const _component_SensitiveDataList = _resolveComponent("SensitiveDataList")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        src: _ctx.logo_URL,
        style: {"max-width":"min(66vw, 400px)","max-height":"72px"}
      }, null, 8, _hoisted_3)
    ]),
    _hoisted_4,
    _hoisted_5,
    _createElementVNode("div", _hoisted_6, [
      _hoisted_7,
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("a", {
          class: _normalizeClass(["cmpButtonLink manageLink", !(_ctx.consentToSharing &&  _ctx.consentToTargeting && _ctx.consentToSensitiveData) ? '': 'buttonDisabled']),
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.saveSettingsClick(false)))
        }, _hoisted_10, 2),
        _createElementVNode("a", {
          class: "cmpButtonLink acceptLink",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.saveSettingsClick(true))),
          style: {"position":"relative"}
        }, _hoisted_13)
      ]),
      _createVNode(_component_ConsentItem, {
        consent: _ctx.consentToSharing,
        onModelChangeEvent: _cache[2] || (_cache[2] = ($event: any) => (_ctx.consentToSharing = ! _ctx.consentToSharing)),
        label: "Consent to Sale and Sharing of Personal Data"
      }, null, 8, ["consent"]),
      _createVNode(_component_ConsentItem, {
        consent: _ctx.consentToTargeting,
        onModelChangeEvent: _cache[3] || (_cache[3] = ($event: any) => (_ctx.consentToTargeting = ! _ctx.consentToTargeting)),
        label: "Consent to Targeted Advertising"
      }, null, 8, ["consent"]),
      _createVNode(_component_SensitiveDataList, {
        cmpApi: _ctx.cmpApi,
        sensitiveFeatures: _ctx.sensitiveFeatures,
        leadText: _ctx.sensitiveLeadText,
        sectionName: _ctx.sectionName,
        fieldName: "SensitiveDataProcessing",
        onModelChangeEvent: _cache[4] || (_cache[4] = ($event: any) => (_ctx.sensitiveDataChange($event)))
      }, null, 8, ["cmpApi", "sensitiveFeatures", "leadText", "sectionName"]),
      (_ctx.privacyPageURL)
        ? (_openBlock(), _createElementBlock("p", _hoisted_14, [
            _createTextVNode(" Your choices apply only to this site. You may adjust your settings at any time in the future by clicking the 'Privacy Choices' link at the bottom of pages on this site or by visiting the "),
            _createElementVNode("a", {
              target: "_blank",
              href: _ctx.privacyPageURL
            }, "privacy policy", 8, _hoisted_15),
            _createTextVNode(" page. ")
          ]))
        : (_openBlock(), _createElementBlock("p", _hoisted_16, "Your choices apply only to this site. You may adjust your settings at any time in the future by clicking the 'Privacy Choices' link at the bottom of pages on this site or by visiting the privacy policy page."))
    ])
  ]))
}